import Grid from "@mui/material/Unstable_Grid2/Grid2"
import ListaEntradas from "../../../../Components/ListaEntradas/ListaEntradas"
import { useContext } from "react"
import { VisitantesContext } from "../../../../Providers/VisitantesContext/VisitantesContext"

const LiberaAcessoEntregador = () => {
    const { liberarAcessoVisitantes } = useContext(VisitantesContext)
    return (
        <Grid sx={{ width: '97%' }}>
            <ListaEntradas
                callbackAbrirPorta={liberarAcessoVisitantes}
            />
        </Grid>
    )
}

export default LiberaAcessoEntregador
